import React, { useState, useEffect } from "react";
import { useParams,useLocation } from "react-router-dom";
import {LandingHostel} from '../../assets';
import { FaCheck } from "react-icons/fa";
import { Helmet } from "react-helmet";


const capitalizeFirstLetter = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

const Page4 = () => {
  const [activeTab, setActiveTab] = useState("sem1");
  const location = useLocation();
  const { city } = useParams();
  const [cityName, setCityName] = useState(city ? capitalizeFirstLetter(city) : "");
  useEffect(() => {
    if (city) {
      setCityName(capitalizeFirstLetter(city));
    }
  }, [city]);

  const path = location.pathname;

  let seoData = {
    title: "MBA Finance in Pune | Best Program by FINXL Business School",
    description: "Get ready for a successful finance career with MBA Finance in Pune at FINXL Business School. Learn from experts and get hands-on experience in the finance.",
  };

  if (path.includes('/mba-finance-college/')) {
    seoData = {
      title: `MBA Finance College in Pune | Placements, Syllabus, Duration`,
      description: `Apply to top MBA Finance college in Pune. Check placement stats, syllabus highlights, and course duration. Limited seats—enroll today!.`,
      keywords: `MBA Finance College in Pune, Top MBA College in Pune, Top MBA Finance College in Pune,  MBA College in Pune, MBA Finance in Pune, Master of Business Administration (MBA), Master of Business Administration (MBA) in Pune, Master of Business Administration (MBA) College in Pune, Business School in Pune, Top Business School in Pune,  Top MBA Program in Pune, Best MBA Program in Pune, Top College For MBA in Pune, Best MBA Colleges in Pune, Best Finance MBA Colleges in Pune, colleges in Pune for MBA, Best management college in Pune, Maharashtra, Finxl Business School(FBS) Pune, best college in pune,top colleges in pune, Finxl Business School(FBS) pune coursestop ten colleges in pune, mba colleges in pune, best mba colleges in pune, top mba colleges in pune, good mba colleges in pune, mba institutes in pune, best university for online mba, top online mba programs, mba best colleges, MBA Finance College in Maharashtra, MBA Finance College in India`,
      h1: `MBA Finance College in Pune`
    };
  } else if (path.includes('/best-mba-college/')) {
    seoData = {
      title: `Best MBA College in Pune - FINXL BUSINESS SCHOOL`,
      description: `Join Best MBA College in pune & Get quality education, industry exposure, good opportunities, expert faculty, and strong placement support.`,
      keywords: `MBA College in Pune, Top MBA College in Pune, MBA College in Pune, MBA in Pune, Master of Business Administration (MBA), Master of Business Administration (MBA) in Pune, Master of Business Administration (MBA) College in Pune, Business School in Pune, Top Business School in Pune,  Top MBA Program in Pune, Best MBA Program in Pune, Top College For MBA in Pune, Best MBA Colleges in Pune, Best Finance MBA Colleges in Pune, colleges in Pune for MBA, Best management college in Pune, Maharashtra, Finxl Business School(FBS) Pune, best college in pune,top colleges in pune, Finxl Business School(FBS) pune coursestop ten colleges in pune, mba colleges in pune, best mba colleges in pune, top mba colleges in pune, good mba colleges in pune, mba institutes in pune, MBA Marketing in Pune, MBA Marketing College in Pune, Best MBA Marketing College in Pune, Top MBA Marketing COllege in Pune, MBA Human Resource Management in Pune, Best MBA HR COllege in Pune, top mba programs, mba best colleges, MBA Finance College in Maharashtra, MBA Finance College in India`,
      h1: `Best MBA College in Pune`
    };
  } else if (path.includes('/master-of-business-administration-mba/')) {
    seoData = {
      title: `Master of Business Administration (MBA)- Business School Pune`,
      description: `Pursue a Master of Business Administration (MBA) in Pune at top business schools offers  real-world training, top-tier placements to boost your career.`,
      keywords: `MBA College in Pune, Top MBA College in Pune, MBA College in Pune, MBA in Pune, Master of Business Administration (MBA), Master of Business Administration (MBA) in Pune, Master of Business Administration (MBA) College in Pune, Business School in Pune, Top Business School in Pune,  Top MBA Program in Pune, Best MBA Program in Pune, Top College For MBA in Pune, Best MBA Colleges in Pune, Best Finance MBA Colleges in Pune, colleges in Pune for MBA, Best management college in Pune, Maharashtra, Finxl Business School(FBS) Pune, best college in pune,top colleges in pune, Finxl Business School(FBS) pune coursestop ten colleges in pune, mba colleges in pune, best mba colleges in pune, top mba colleges in pune, good mba colleges in pune, mba institutes in pune, best university for online mba, top online mba programs, mba best colleges, MBA Finance College in Maharashtra, MBA Finance College in India`,
      h1: `Master of Business Administration (MBA) in Pune`
    };
  }



  useEffect(() => {
    if (city) {
      setCityName(capitalizeFirstLetter(city));
    }
  }, [city]);

  const semesters = {
    sem1: {
      compulsory: [
        "Managerial Accounting",
        "Organizational Behavior",
        "Economics Analysis for Business",
        "Business Research Methodology",
        "Basics of Marketing",
        "Digital Business",
      ],
      electives: [
        {
          note: "Maximum 3 courses to be selected from the following list",
          subjects: [
            "Management Fundamentals",
            "Indian Economy",
            "Legal Aspects of Business",
            "Verbal Communication Lab",
            "MS Excel",
            "Entrepreneurship- Managing Skills for MSMEs-Seminar",
            "Desk Research- Best Business Practices-Case Study",
          ],
        },
        {
          note: "Maximum 3 courses to be selected from the following list",
          subjects: [
            "Verbal Communication Lab",
            "Enterprise Analysis & Desk Research",
            "Selling & Negotiation Skills Lab",
            "MS Excel",
            "Business Systems & Procedures",
            "Managing Innovation",
            "Foreign Language – I",
          ],
        },
      ],
    },
    sem2: {
      compulsory: [
        "Marketing Management",
        "Financial Management",
        "Human Resources Management",
        "Operations & Supply Chain Management",
        "Personal Financial Planning",
        "Financial Markets and Banking Operations",
      ],
      electives: [
        {
          note: "Any 3 courses to be selected from the following list",
          subjects: [
            "Contemporary Frameworks in Management",
            "Geopolitics & World Economic Systems",
            "Start Up and New Venture Management",
            "Qualitative Research Methods",
            "Business, Government & Society",
            "Business Process Re-engineering",
          ],
        },
        {
          note: "Maximum 1 course to be selected from the following list",
          subjects: [
            "Written Analysis and Communication Lab",
            "Industry Analysis & Desk Research",
            "Entrepreneurship Lab",
            "SPSS",
            "Foreign Language II",
          ],
        },
        {
          note: "Maximum 2 courses to be selected from the following list",
          subjects: [
            "Securities Analysis & Portfolio Management",
            "Futures and Options",
            "Direct Taxation",
            "Financial Reporting",
            "Retail Credit Management- Lending & Recovery",
            "Banking Laws & Regulations",
            "Fundamentals of Life Insurance – Products and Underwriting",
            "General Insurance - Health and Vehicle",
          ],
        },
      ],
    },
    sem3: {
      compulsory: [
        "Strategic Management",
        "Decision Science",
        "Summer Internship Project",
        "Advanced Financial Management",
        "International Finance",
      ],
      electives: [
        {
          note: "Any 3 courses to be selected from the following list",
          subjects: [
            "International Business Economics",
            "International Business Environment",
            "Project Management",
            "Quality Management",
            "Corporate Governance",
            "Management of Non-profit organizations",
          ],
        },
        {
          note: "Maximum 3 courses to be selected from the following list",
          subjects: [
            "Behavioral Finance",
            "Commodities Markets",
            "Indirect Taxation",
            "Corporate Financial Restructuring",
            "Financial Modeling",
            "FIN Digital Banking",
            "Treasury Management",
            "Project Finance and Trade Finance",
            "Insurance Laws & Regulations",
            "Marine Insurance",
            "Fire Insurance",
          ],
        },
      ],
    },
    sem4: {
      compulsory: [
        "Enterprise Performance Management",
        "Indian Ethos & Business Ethics",
        "Financial Laws",
        "Current Trends & Cases in Finance",
      ],
      electives: [
        {
          note: "Any 2 courses to be selected from the following list",
          subjects: [
            "Global Strategic Management",
            "Elective Competing in Global Markets",
            "Elective Cyber Laws",
            "CSR & Sustainability",
          ],
        },
        {
          note: "Maximum 2 courses to be selected from the following list",
          subjects: [
            "Fixed Income Securities",
            "Business Valuation",
            "Risk Management",
            "Strategic Cost Management",
            "Rural and Micro Finance",
            "Reinsurance",
            "Agricultural Insurance",
          ],
        },
      ],
    },
  };



  return (
  <>
  <Helmet>
        <title>{seoData.title}</title>
        <meta name="description" content={seoData.description} />
        <meta name="keywords" content={seoData.keywords} />
        <link rel="canonical" href={`https://fbsedu.in${path}`} />
      </Helmet>
    

    <div className="max-w-7xl mx-auto py-6 px-6">
      <h1 className="text-3xl font-extrabold text-center text-blue-600 mb-4">
        {seoData.h1 || "MBA Finance Program in Pune"}
      </h1>

      {/* About Section */}
      <section className="flex flex-col md:flex-row items-center bg-white p-6 rounded-lg shadow-lg mb-6" id="about-section">
        {/* Left Text Section */}
        <div className="bg-blue-50 p-6  rounded-lg md:w-1/2">
          <h2 className="text-2xl font-bold text-gray-900 mb-3">
            {cityName ? `Join Our ${seoData.h1}` : `Join Our MBA Finance Program`}
          </h2>
          <p className="text-gray-700 mb-4">
            Empowering future finance leaders through innovative education and
            guaranteed placements.
          </p>
          <a
            href="https://fbsedu.in/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="bg-orange-500 text-white px-4 py-2 rounded-lg font-semibold hover:bg-orange-600">
              Get in touch with us
            </button>
          </a>
        </div>

        {/* Right Image Section */}
        <div className="md:w-1/2 flex justify-center mt-4 md:mt-0">
          <img
            src={LandingHostel}
            alt="MBA Finance Program"
            className="max-w-full h-auto rounded-lg"
          />
        </div>
      </section>


      {/* About MBA Finance Course Section */}
      <section className="bg-white p-4 sm:p-6 rounded-lg shadow-lg mb-6" id="about-course-section">
        <h2 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-4 text-left">
          {cityName ? `About ${seoData.h1} Course` : `About MBA Finance Course`}
        </h2>
        <ul className="text-gray-700 space-y-3">
          <li className="flex items-start text-sm sm:text-base">
            <FaCheck className="text-green-600 mt-1 mr-2" />
            The {cityName ? `${seoData.h1}` : `MBA Finance`} is a 2-year full-time program designed to equip students with financial skills.
          </li>
          <li className="flex items-start text-sm sm:text-base">
            <FaCheck className="text-green-600 mt-1 mr-2" />
            Real-time case studies, expert support, resume preparation, lifetime access to FINXL LMS.
          </li>
          <li className="flex items-start text-sm sm:text-base">
            <FaCheck className="text-green-600 mt-1 mr-2" />
            FBS guarantees placement in the core finance sector with a one-year job experience letter.
          </li>
          <li className="flex items-start text-sm sm:text-base">
            <FaCheck className="text-green-600 mt-1 mr-2" />
            Attractive return on investment with competitive salary packages.
          </li>
        </ul>

        {/* Who Should Apply Section */}
        <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mt-6 mb-4 text-left">
          {cityName ? `Who Should Apply For ${seoData.h1}?` : `Who Should Apply For MBA Finance Program ?`}
        </h3>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 justify-center p-2 sm:p-4">
          <div className="bg-orange-200 p-6 sm:p-8 rounded-lg text-center font-semibold min-h-[120px] sm:min-h-[150px] flex items-center justify-center hover:bg-orange-300 hover:shadow-xl transition-all duration-300">
            Those looking to specialize in financial analysis and equity research.
          </div>
          <div className="bg-orange-200 p-6 sm:p-8 rounded-lg text-center font-semibold min-h-[120px] sm:min-h-[150px] flex items-center justify-center hover:bg-orange-300 hover:shadow-xl transition-all duration-300">
            Individuals aiming to excel in investment banking.
          </div>
          <div className="bg-orange-200 p-6 sm:p-8 rounded-lg text-center font-semibold min-h-[120px] sm:min-h-[150px] flex items-center justify-center hover:bg-orange-300 hover:shadow-xl transition-all duration-300">
            Professionals seeking to provide strategic financial advice.
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 p-2 sm:p-4">
          <div className="bg-orange-200 p-6 sm:p-8 rounded-lg text-center font-semibold min-h-[120px] sm:min-h-[150px] flex items-center justify-center hover:bg-orange-300 hover:shadow-xl transition-all duration-300">
            Working Professionals: Executive MBA, part-time MBA, online MBA, and accelerated programs.
          </div>
          <div className="bg-orange-200 p-6 sm:p-8 rounded-lg text-center font-semibold min-h-[120px] sm:min-h-[150px] flex items-center justify-center hover:bg-orange-300 hover:shadow-xl transition-all duration-300">
            Graduates with a bachelor's degree and a passion for finance.
          </div>
        </div>
      </section>

      {/* Eligibility Section */}
      <section className="bg-white p-6 rounded-lg shadow-lg mb-6" id="eligibility-section">
        <h2 className="text-2xl font-semibold text-gray-900 mb-6">
          {cityName ? `Who is Eligible for the ${seoData.h1}?` : `Who is Eligible for the MBA Finance Program ? `}
        </h2>
        <div className="flex flex-col md:flex-row font-semibold justify-center items-center gap-12 md:gap-16 mb-8">
          {/* Small Circle */}
          <div
            className="w-40 h-40 flex items-center justify-center rounded-full text-center p-4 
                  bg-gradient-to-r from-blue-400 to-blue-600 text-white shadow-lg
                  transition-transform transform hover:scale-110 hover:shadow-2xl"
          >
            A bachelor's degree with a minimum of 50% marks.
          </div>

          {/* Larger Circle */}
          <div
            className="w-60 h-60 flex items-center justify-center rounded-full text-center p-6 font-semibold
                  bg-gradient-to-r from-orange-400 to-orange-600 text-white shadow-xl
                  transition-transform transform hover:scale-110 hover:shadow-2xl"
          >
            Based on academic performance, entrance exam scores, and personal
            interviews.
          </div>

          {/* Small Circle */}
          <div
            className="w-40 h-40 flex items-center justify-center rounded-full text-center p-4
                  bg-gradient-to-r from-green-400 to-green-600 text-white shadow-lg
                  transition-transform transform hover:scale-110 hover:shadow-2xl"
          >
            CAT, CMAT, MAT, XAT, MH-CET.
          </div>
        </div>

        {/* Program Features */}
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">
          Program Features
        </h2>
        <div className="bg-blue-100 p-6 rounded-lg">
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-900">
            <li className="flex items-start">
            <FaCheck className="text-purple-600 mt-1 mr-2 h-4 w-4"/>Online support from a dedicated team for all queries.
            </li>
            <li className="flex items-start">
            <FaCheck className="text-purple-600 mt-1 mr-2 h-4 w-4"/>Assistance in resume building and job portal updates.
            </li>
            <li className="flex items-start">
            <FaCheck className="text-purple-600 mt-1 mr-2 h-4 w-4"/>Obtain certifications in financial modeling, equity research,
              and advanced Excel.
            </li>
            <li className="flex items-start">
            <FaCheck className="text-purple-600 mt-1 mr-2 h-4 w-4"/>Access to FINXL LMS with videos, spreadsheets, presentations,
              ebooks, quizzes, and case studies.
            </li>
            <li className="flex items-start">
            <FaCheck className="text-purple-600 mt-1 mr-2 h-4 w-4"/>Live case studies for each financial topic to ensure thorough
              understanding.
            </li>
            <li className="flex items-start">
            <FaCheck className="text-purple-600 mt-1 mr-2 h-4 w-4"/>A dynamic platform to connect with experts across the globe.
            </li>
          </ul>
        </div>
      </section>


      {/* Admissions Process */}
      <section className="bg-white p-6 rounded-lg shadow-lg mb-6" id="admission-section">
        <div className="p-6">
          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              Admissions Process
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {/* Step 1 */}
              <div className="flex items-start space-x-4">
                <span className="text-red-600 text-xl font-bold">Step 01</span>
                <span className="border-l-2 border-gray-500 pl-4 text-gray-700">
                  Online application form available on the FBS website.
                </span>
              </div>
              {/* Step 2 */}
              <div className="flex items-start space-x-4">
                <span className="text-red-600 text-xl font-bold">Step 02</span>
                <span className="border-l-2 border-gray-500 pl-4 text-gray-700">
                  CAT, CMAT, MAT, XAT, MH-CET.
                </span>
              </div>
              {/* Step 3 */}
              <div className="flex items-start space-x-4">
                <span className="text-red-600 text-xl font-bold">Step 03</span>
                <span className="border-l-2 border-gray-500 pl-4 text-gray-700">
                  Personal interviews for shortlisted candidates.
                </span>
              </div>
              {/* Step 4 */}
              <div className="flex items-start space-x-4">
                <span className="text-red-600 text-xl font-bold">Step 04</span>
                <span className="border-l-2 border-gray-500 pl-4 text-gray-700">
                  Based on performance in entrance exams and interviews.
                </span>
              </div>
            </div>
          </section>
        </div>

        {/* How We Train */}

        {/* Placements */}
        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Placements</h2>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-center h-100 p-6">
            <div className="bg-blue-600 text-white p-6 rounded-lg shadow-lg transition-transform duration-300 hover:scale-105">
              <p className="text-xl font-bold">INR 7.00 Lakh</p>
              <p className="text-sm">Average Package</p>
            </div>
            <div className="bg-blue-600 text-white p-6 rounded-lg shadow-lg transition-transform duration-300 hover:scale-105">
              <p className="text-xl font-bold">INR 22.00 Lakh</p>
              <p className="text-sm">Highest Package</p>
            </div>
            <div className="bg-blue-600 text-white p-6 rounded-lg shadow-lg transition-transform duration-300 hover:scale-105">
              <p className="text-xl font-bold">100% placement</p>
              <p className="text-sm">Placement Rate</p>
            </div>
          </div>
        </section>
      </section>
      {/* MBA Finance Syllabus */}
      <div className="w-full mx-auto p-4 bg-white rounded-lg shadow-lg">
        <div className="bg-gray-100 p-4 rounded-lg mb-4">
          <h2 className="text-2xl font-semibold text-gray-900 mb-2">
          {cityName ? `${seoData.h1}` : `MBA Finance`} Syllabus
          </h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            The {cityName ? `${seoData.h1}` : `MBA Finance`} syllabus at FBS is carefully crafted to give you a
            competitive edge. Explore the courses across different semesters:
          </p>
        </div>

        <div className="bg-white shadow-lg rounded-lg">
          <div className="border-b">
            <nav className="flex flex-wrap justify-center">
              {["SEMESTER I", "SEMESTER II", "SEMESTER III", "SEMESTER IV"].map(
                (sem, idx) => (
                  <button
                    key={idx}
                    onClick={() => setActiveTab(`sem${idx + 1}`)}
                    className={`px-6 py-3 font-medium text-sm transition-colors
                    ${activeTab === `sem${idx + 1}`
                        ? "border-b-2 border-blue-500 text-blue-600"
                        : "text-gray-500 hover:text-gray-700"
                      }`}
                  >
                    {sem}
                  </button>
                )
              )}
            </nav>
          </div>

          {/* Semester Content */}
          <div className="overflow-x-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-gray-50">
                  <th className="p-4 text-center text-sm font-medium text-gray-600 border">
                    Semester
                  </th>
                  <th className="p-4 text-center text-sm font-medium text-gray-600 border">
                    Subject
                  </th>
                  <th className="p-4 text-center text-sm font-medium text-gray-600 border">
                    Type
                  </th>
                </tr>
              </thead>
              <tbody>
                {/* Compulsory Subjects */}
                <tr>
                  <td className="p-4 border">SEMESTER {activeTab.slice(-1)}</td>
                  <td className="p-4 border">
                    <ul className="list-disc pl-5 space-y-1">
                      {semesters[activeTab].compulsory.map((subject, idx) => (
                        <li key={idx}>{subject}</li>
                      ))}
                    </ul>
                  </td>
                  <td className="p-4 border">Compulsory</td>
                </tr>

                {/* Electives Sections */}
                {semesters[activeTab].electives.map((section, sectionIdx) => (
                  <React.Fragment key={sectionIdx}>
                    <tr>
                      <td
                        colSpan="3"
                        className="p-4 border font-medium text-center bg-gray-50"
                      >
                        {section.note}
                      </td>
                    </tr>
                    <tr>
                      <td className="p-4 border">
                        SEMESTER {activeTab.slice(-1)}
                      </td>
                      <td className="p-4 border">
                        <ul className="list-disc pl-5 space-y-1">
                          {section.subjects.map((subject, idx) => (
                            <li key={idx}>{subject}</li>
                          ))}
                        </ul>
                      </td>
                      <td className="p-4 border">Electives</td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </>
  );
};

export default Page4;